<script setup>
import { onMounted, ref } from 'vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Head, Link } from '@inertiajs/inertia-vue3';
import VueCal from "vue-cal";
import 'vue-cal/dist/vuecal.css'
import CardBoxModal from "@/Components/CardBoxModal.vue";
import BaseButton from "@/Components/BaseButton.vue";
import { mdiPlusCircle } from "@mdi/js";

const props = defineProps ({
    events: Array,
    id_user: Number,
    canCreate: Boolean,
    canUpdate: Boolean,
    canDelete: Boolean
});

const msg1 = ref('')
onMounted(() => {
    //console.log(msg)
   // msg1.value = msg
});

const pruebaevents = [
        {id: 1, start: '2023-04-19 12:00:20', end: '2023-04-19 12:00:20', title: 'Más trabajo, está bien 1', content: 'es mejor que halla más trabajo 1', deletable: 1 },
        {id: 2, start: '2023-04-20 12:00', end: '2023-04-23 17:00', title: 'Más trabajo, está bien 2', content: '<font color="green">es mejor</font> que halla más trabajo 2', split: 1 },
        {id: 3, start: '2023-04-20 12:00', end: '2023-04-21 14:00', title: 'Más trabajo, está bien 3', content: 'es mejor que halla más trabajo 3', allday: 1 },
        {id: 4, start: '2023-04-17 12:00', end: '2023-04-18 13:00', title: 'Más trabajo, está bien 4', content: 'es mejor que halla más trabajo 4', resizable: 1 }
    ]

const isModalActive = ref(false)
const selectedEvent = ref({})
const showDialog = ref(false)
const isModalDangerActive = ref(false);
const titleModal = ref('')

const onEventClick = (event, e) => {
    selectedEvent.value = event
    showDialog.value = true
    // Prevent navigating to narrower view (default vue-cal behavior).
    e.stopPropagation()
}

const initModal = (id, action, data = []) => {
    
}

const isConfirm = () => {

}

const isCancel = () => {
    
    cleanVal()
}

const cleanVal = (cleanEditor=1) => {

/* rowID.value = 0;
rowAction.value = ''
modalFullSrc.value = ''

// Tarea
if (cleanEditor) {// <-- No borrar si cierro el editor en nueva edición
    formTarea.label = ''
    formTarea.description = ''
    formTarea.end_date = null
    formTarea.status = 0
    tareaEditor.value.setContents('')// <-- Limpiar contenido de texto enriquecido
} */
}

</script>

<template>
    <Head title="Aulas" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Agenda <!-- {{ confGlobal.value.UNENS_SEDE_NOMBRE }} -->
            </h2>
        </template>
        <CardBoxModal
            v-model="showDialog"
            :title="(selectedEvent.title ? selectedEvent.title : 'Información del evento')"
            hasCancel   
        >
            <!-- <v-icon>{{ selectedEvent.icon }}</v-icon> -->
            <strong>{{ selectedEvent.start && selectedEvent.start.format('DD/MM/YYYY') }} : 
                {{ selectedEvent.start && selectedEvent.start.formatTime() }} - 
                {{ selectedEvent.end && selectedEvent.end.formatTime() }}
            </strong>
            <p v-html="selectedEvent.contentFull"/>
            <!-- <strong>Info.:</strong>
                <ul>
                    <li>Inicio: {{ selectedEvent.start && selectedEvent.start.formatTime() }}</li>
                    <li>Fin: {{ selectedEvent.end && selectedEvent.end.formatTime() }}</li>
                </ul> -->
        </CardBoxModal>
        <CardBoxModal v-model="isModalActive" hasCancel :title="titleModal" @confirm="isConfirm" @cancel="isCancel">
        </CardBoxModal>
        <CardBoxModal
            v-model="isModalDangerActive"
            title="Por Confirmar"
            button="danger"
            hasCancel
            @confirm="isConfirm"
            @cancel="isCancel"
        >
            <p>Está seguro de <b>{{ titleModal }}</b></p>
            <p>este registro?</p>
        </CardBoxModal>
        
        <div class="py-12">
            <div class="container mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div v-if="!id_user" class="p-6 bg-white border-b border-gray-200">
                        <!-- Registro Diario -->
                        <li>(A): Asistencia</li>
                        <li>(F): Falta</li>
                        <li>(T): Tardanza</li>

                            <div class="block h-full w-full">
                                <VueCal
                                :transitions="false"
                                small
                                :time="false"
                                locale="es"
                                hide-view-selector
                                :disable-views="['years', 'year', 'day', 'month']"
                                :events="events"
                                class="cal-rose"
                                active-view="week"
                                hide-weekends
                            />
                            </div>
                        
                    </div>
                    <div v-else class="p-6 bg-white border-b border-gray-200">
                        <!-- Agenda -->
                        <div>
                            <Link href="#"><!-- :href="route(rutaPrefijo+'-create')" -->
                                <BaseButton
                                    color="info"
                                    :icon="mdiPlusCircle"
                                    small
                                    label=" Crear evento"
                                    class="ml-8 mb-4 inline-flex cursor-pointer justify-center items-center whitespace-nowrap focus:outline-none transition-colors focus:ring duration-150 border rounded border-blue-600 dark:border-blue-500 ring-blue-300 dark:ring-blue-700 bg-blue-600 dark:bg-blue-500 text-white hover:bg-blue-700 hover:border-blue-700 hover:dark:bg-blue-600 hover:dark:border-blue-600 p-1 float-right"
                                />
                            </Link>
                        </div>
                        <br>

                            <!-- Documentación: https://antoniandre.github.io/vue-cal/?ref=madewithvuejs.com -->
                            <!-- Ejemplo: https://codepen.io/antoniandre/pen/jJbygw?editors=1010 -->
                            <!-- If the container has no height, set a height on vue-cal -->
                            <!-- vuecal--green-theme o vuecal--blue-theme -->
                            <!-- active-view="month" por defecto se ve por semana en la confiuración anterior -->
                            
                            <!-- https://antoniandre.github.io/vue-cal/#ex--calendar-themes -->
                            <!-- vuecal--rounded-theme -->
                            <!-- hide-view-selector  es para ocultar la sección de la vista tipo mes o semana-->
                            <!-- xsmall  lo establece en formato pequeño y el nombre de días lo pone en abreviado-->

                            <!-- Otros estilos -->
                            <!-- https://antoniandre.github.io/vue-cal/#css-notes -->

                            <!-- <div class="block h-full w-full">
                                <VueCal
                                xsmall
                                :time="false"
                                locale="es"
                                hide-view-selector
                                :disable-views="['years', 'year']"
                                :events="events"
                                class="vuecal--date-picker vuecal--green-theme"
                                active-view="week"
                                hide-weekends
                                
                                />
                            </div> -->

                            <div class="block h-full w-full">
                                <VueCal
                                :transitions="false"
                                small
                                :time="false"
                                locale="es"
                                hide-view-selector
                                :disable-views="['years', 'year', 'day', 'month']"
                                :events="events"
                                class="cal-rose"
                                active-view="week"
                                hide-weekends
                            />
                            <!-- xsmall abreviatura de los títulos de días L, M, M -->
                            <!-- :on-event-click="onEventClick" -->
                            </div>
                        
                    </div>
                </div>
            </div>
        </div>
    </BreezeAuthenticatedLayout>
</template>
